import React from 'react';
import { Elements } from '@stripe/react-stripe-js';
import { loadStripe } from '@stripe/stripe-js';

interface Props {
    children: React.ReactNode;
    stripeKey: string;
  }
  

const StripeProvider: React.FC<Props> = ({ children , stripeKey}) => {

    const stripePromise = loadStripe(stripeKey as string); // Replace with your Stripe publishable key
    return (
        <Elements stripe={stripePromise}>
            {children}
        </Elements>
    );
};

export default StripeProvider;
